export default __webpack_public_path__ + "static/media/stickerBackground.6e811e64.jpg";